import React, { useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChevronLeft, ChevronRight, Grid } from 'react-feather';

const Spectra = (props) => {

    // Adding custom class to body 
    useEffect(() => {
        props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    })

    return (
        <Fragment>
            <section id="single-project-wrapper">
                <div className="single-project">
                    <div className="container-fluid">
                        <div className="w-full">
                            <div>
                                <div className="h-[100px]"></div>
                                <iframe width="100%" height="650" src="https://www.youtube-nocookie.com/embed/r1pxCv8HOu4?autoplay=1&mute=1&loop=1&playlist=r1pxCv8HOu4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="max-w-default w-default px-12 py-28 lg:py-24 md:py-16 sm:py-4 container-wrapper">
                            <div className="single-project-details">
                                <div className='breadcrumbs pb-4'>
                                    <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-work'>Our Work</Link><span>{'>'}</span><Link to='/spectra-draw-the-line' className='current'>Draw the Line</Link></li>
                                </div>
                                <div className="flex lg:flex-row md:flex md:flex-col sm:flex-col single-project-details-wrapper">
                                    <div className="single-project-details-left grid grid-rows-1 grid-cols-2 gap-20">
                                        <div className="details-project-name">
                                            <h3 className="heading5 pb-8">Project Name</h3>
                                            <h1>Draw the Line</h1>
                                        </div>
                                        <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Website</p>
                                            {/* <p><a href="https://staging1.mslgroup.tech/spectra/spectra-website/" target={"_blank"} rel="noopener noreferrer">https://staging1.mslgroup.tech/spectra/spectra-website/</a></p> */}
                                        </div>
                                        {/* <div>
                                                <h3 className="heading5 pb-8">Type</h3>
                                                <p>Social Media</p>
                                            </div> */}
                                        {/* <div>
                                                <h3 className="heading5 pb-8">Website</h3>
                                                <p>lorem Ipsum</p>
                                            </div> */}
                                    </div>
                                    <div className="single-project-details-right lg:pt-0 lg:py-16 md:pt-12">
                                        <div>
                                            <h2 className="heading5 pb-8">The Ask</h2>
                                            <p>To initiate conversations around cyberbullying and to act upon the responsibility of an internet service provider, to do what is needed to create a safe space online for internet users.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="single-project-details-images pb-16">
                                    <iframe width="100%" height="600" src="https://www.youtube-nocookie.com/embed/r1pxCv8HOu4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div> */}
                                <div className="single-project-body">
                                    <h2 className="heading4 pb-8">What we did</h2>
                                    <p>A 360 degree campaign hubbed on a microsite which was a dedicated resource center on cyber bullying including advice and actionable recommendations for victims and impacted audiences. Social media was leveraged extensively to drive awareness and audiences to the site and partnering like minded communities like Terribly Tiny Tales and Natak pictures helped widen the reach of the campaign. The campaign concluded with Instagram live sessions with experts helping audiences understand the issue and the ways in which they can protect themselves. Overall, the campaign highlighted an issue that is increasingly plaguing audiences and enabled users to be proactive, aware of their rights and use the internet free from the fear of cyber bullying.</p>
                                   
                                    <h2 className="heading4 pt-16 pb-8 what-campaign-achived">
                                        What the campaign achieved
                                    </h2>
                                    <div className="results">
                                        <div>
                                            <h1>6.35M+</h1>
                                            <h2>Reach</h2>
                                        </div>
                                        <div>
                                            <h1>7.3M+</h1>
                                            <h2>Impressions</h2>
                                        </div>
                                        <div>
                                            <h1>1M+</h1>
                                            <h2>Engagements</h2>
                                        </div>
                                    </div>

                                    <div className="pagination">
                                        <div><Link to='/my-cams-app'><ChevronLeft /><span>Previous</span></Link></div>
                                        <div><Link to='/our-work'><Grid /><span>All Projects</span></Link></div>
                                        <div><Link to='/godaddy-india'><ChevronRight /><span>Next</span></Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
            <section id='take-next-leap' key='single-project'>
                <div className='take-next-leap'>
                    <div className='take-next-leap__left'>
                        <h1 className="heading4 black">Let’s create <span>impact together.</span></h1>
                    </div>
                    <div className='take-next-leap__right'>
                        <p><Link to='/contact-us'>Contact us today<ArrowUpRight /></Link></p>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
        </Fragment>
    );
};

export default Spectra;